import { api } from "api/base";

export const getRoutes = async (driverId: string) => {
    try {
        const response = await api.get(`/routes/driver/${driverId}`);
        if (response.status === 200) {
            return response.data;
        } else {
            console.log(response);
            return null;
        }
    } catch (error) {
        console.log(error);
        return null;
    }
};

export const createRoute = async ({driverId, orderIds, name}: {driverId: string, orderIds: string[], name: string}) => {
    const response = await api.post('/routes/create', { driver_id: driverId, order_ids: orderIds, name });
    if (response.status === 200) {
        return response.data;
    } else {
        return null;
    }
};

export const addOrdersToRoute = async ({routeId, orderIds}: {routeId: string, orderIds: string[]}) => {
    try {
        const response = await api.post('/routes/add_orders', { route_id: routeId, order_ids: orderIds });
        if (response.status === 200) {
            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.log(error);
        return null;
    }
};

export const removeOrdersFromRoute = async ({routeId, orderIds}: {routeId: string, orderIds: string[]}) => {
    const response = await api.delete('/routes/remove_orders', { data: { route_id: routeId, order_ids: orderIds } });
    if (response.status === 200) {
        return response.data;
    } else {
        return null;
    }
};

export const getUnassignedRoutes = async () => {
    const response = await api.get('/routes/unassigned');
    if (response.status === 200) {
        return response.data;
    } else {
        return null;
    }
};
